import { ChangeDetectorRef, Component, EventEmitter, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { PHBHPLayoutPackageService, PHBHPListApiService } from 'ph-bhp-feature-packages/ph-bhp-layout-package/public_api';
import { ChecksService, Question, QuestionnaireDTO, QuestionType } from 'ph-bhp-feature-packages/ph-bhp-feature-package-check/public_api';
import { QuestionnairesService } from 'ph-bhp-feature-packages/ph-bhp-feature-package-check/lib/services/questionnaires.service';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { AppConfig } from 'src/app/app.config';
import { FiltersService } from 'src/app/services/filters.service';

@Component({
  selector: 'hygiene-check-questionnaire-editor',
  templateUrl: './hygiene-check-questionnaire-editor.component.html',
  styleUrls: ['./hygiene-check-questionnaire-editor.component.scss']
})
export class HygieneCheckQuestionnaireEditorComponent implements OnInit {
  @ViewChild('deleteModal') deleteModal: TemplateRef<any>;

  modalRef: BsModalRef;
  questionnaireId: string = '';
  questionnaire: QuestionnaireDTO;
  isCollapsed: boolean = true;
  additionalInfoSelected: any = '';
  userId: number;
  captionData: Question = { id: '', statement: '' };
  isCaptionCollapsed: boolean = true;
  showQuestionManager: boolean = false;

  questionTypes: QuestionType[] = [];
  editQuestion: Question;
  fromDuplication: boolean = false;

  constructor(
    public layoutService: PHBHPLayoutPackageService,
    public translate: TranslateService,
    private modalService: BsModalService,
    private router: Router,
    private route: ActivatedRoute,
    private questionnaireService: QuestionnairesService,
    private changeDetection: ChangeDetectorRef,
    private config: AppConfig,
    public checksService: ChecksService,
    public filtersService: FiltersService

  ) { }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      this.questionnaireId = params['id'];
      this.userId = this.config.userData.userId;
      this.fromDuplication = this.questionnaireService.fromDuplicate;
      delete this.questionnaireService.fromDuplicate;
      
      if (this.questionnaireService.editQuestionnaire) {
        this.questionnaire = this.questionnaireService.editQuestionnaire;
        this.setQuestionsPosition();
      } else {
        if (this.questionnaireId === 'new') {
          this.questionnaire = {
            id: 'new',
            isDefault: false,
            questionnaireName: '',
            showNotes: true,
            questions: [],
            institutionID: this.layoutService.institutionID,
            countryId:  Number(this.config.userData.country || 0),
            isTemplate: this.config.userData.roleName.roleId < 4
          }
        } else {
          this.layoutService.showLoader = true;
          this.questionnaireService.getQuestionnaireById(this.questionnaireId).subscribe((questionnaire: any) => {
            questionnaire.questions = questionnaire.questions.sort((a, b) => a.position - b.position);
            this.questionnaire = questionnaire;
            this.setQuestionsPosition();
            this.questionnaireService.editQuestionnaire = this.questionnaire;
          }, (error) => {
            console.error(error);
            this.layoutService.showLoader = false;
          }, () => {
            this.layoutService.showLoader = false;
          });
        }
      }

      const navigation = this.router.getCurrentNavigation();
      if (navigation?.extras?.state) {
        let mode = navigation?.extras?.state;
        const newQuestion = navigation.extras.state.newQuestion;
      }
    });

    this.checksService.getQuestionTypes().subscribe({
      next: (res: any) => {
        this.questionTypes =[];
        const sortedQuestionTypes = res.value.map((questionType: QuestionType) => {
            if (questionType.answerOptions && questionType.answerOptions.length > 0) {
                questionType.answerOptions.sort((a, b) => (a.position ?? 0) - (b.position ?? 0));
            }
            return questionType;
        });
        this.questionTypes = this.questionTypes.concat(sortedQuestionTypes);
        this.layoutService.showLoader = false;
      },
      error: () => {
        this.layoutService.showLoader = false;
      }
    });
  }

  

  setQuestionsPosition(): void {
    var questionPosition = 1;
    this.questionnaire.questions.forEach((question, index) => {
      if (question.isDeleted) return;
      question.position = index + 1;
      if (question.isCaption) return;
      question.questionPosition = questionPosition;
      questionPosition++;
    });
  }

  backToQuestionnaireList() {
    this.questionnaireService.editQuestionnaire = null;
    if (this.config.userData.roleName.roleId === 2) {
      this.router.navigate(["/hygiene-check-editor"]);
    } else {
      this.router.navigate(["/hygiene-check-menu/hygiene-check-editor"]);
    }
  }

  openQuestionManager(question) {

    this.showQuestionManager = true;
    this.editQuestion = question;
  }

  closeQuestionManager(question: Question) {
    
    this.showQuestionManager = false;
    if(question?.id){
      let index = this.questionnaire.questions.findIndex(q => q.id === question.id);
      this.questionnaire.questions[index] = question;
    }
    this.setQuestionsPosition();
  }

  drop(event: CdkDragDrop<any[]>) {
    this.questionnaire.questions[event.previousIndex].updatedBy = this.userId;
    this.questionnaire.questions[event.previousIndex].updatedDate = new Date();
    this.questionnaire.questions[event.currentIndex].updatedBy = this.userId;
    this.questionnaire.questions[event.currentIndex].updatedDate = new Date();
    moveItemInArray(this.questionnaire.questions, event.previousIndex, event.currentIndex);
    this.setQuestionsPosition();
    this.changeDetection.detectChanges();
    this.changeDetection.markForCheck();
  }

  getQuestionType(questionTypeId) {
    let qt = this.questionTypes.find(qt => qt.id === questionTypeId);
    if (!qt) return '';
    return qt.questionTypeName;
  }

  addCaption() {
    this.captionData = { id: '', statement: '' };
    this.isCaptionCollapsed = false;
  }

  addQuestion() {
    this.openQuestionManager(null);
  }

  deleteItem(item: Question) {
    const index = this.questionnaire.questions.findIndex(q => q.id === item.id);
    this.questionnaire.questions[index].isDeleted = true;
    this.setQuestionsPosition();
  }

  editItem(item: Question) {
    if (item.isCaption) {
      this.captionData = { ...item };
      this.isCaptionCollapsed = false;
    } else {
      this.questionnaireService.editQuestion = item;
      this.openQuestionManager(item);
    }
  }

  deleteQuestionnaire() {
    this.modalRef = this.modalService.show(this.deleteModal, Object.assign({}, { class: 'w-420' }));
  }

  deleteQuestionnaireConfirmed() {
    if (this.questionnaireId != 'new') {
      this.layoutService.showLoader = true;
      this.questionnaireService.deleteQuestionnaire(this.questionnaireId, this.userId).subscribe(() => {
        this.backToQuestionnaireList();
      }, (error) => {
        console.error(error);
        this.layoutService.showLoader = false;
      }, () => {
        this.layoutService.showLoader = false;
      });
    } else {
      this.backToQuestionnaireList();
    }
  }

  cancelQuestionnaire() {
    this.backToQuestionnaireList();
  }

  saveQuestionnaire() {
    if (this.isSaveDisabled()) return;
    this.layoutService.showLoader = true;
    if (this.questionnaire.id === 'new') {
      delete this.questionnaire.id;
      this.questionnaire.institutionID = this.layoutService.institutionID;
      const roleId = this.config.userData.roleName.roleId;

      this.questionnaireService.createQuestionnaire(this.questionnaire, this.userId, roleId).subscribe(() => {
        this.layoutService.showLoader = false;
        this.backToQuestionnaireList();
      }, (error) => {
        console.error(error);
        this.layoutService.showLoader = false;
      }, () => {
        this.layoutService.showLoader = false;
      });
    } else {
      const dataQuestionnaire = {
        questionnaire: this.questionnaire,
        userId: this.config.userData.userId,
        roleId: this.config.userData.roleName.roleId,
        fromDuplicate: this.fromDuplication
      }

      const roleId = this.fromDuplication ? this.config.userData.roleName.roleId : 0;
      this.questionnaireService.updateQuestionnaire(dataQuestionnaire).subscribe(() => {
        this.layoutService.showLoader = false;
        this.backToQuestionnaireList();
      }, (error) => {
        console.error(error);
        this.layoutService.showLoader = false;
      }, () => {
        this.layoutService.showLoader = false;
      });
    }
  }

  onCaptionHandler(event: any) {
    switch (event.key) {
      case 'close':
        this.isCaptionCollapsed = true;
        break;
      case 'save':
        const caption: Question = event.data;
        if (caption.id && caption.id !== '') {
          const index = this.questionnaire.questions.findIndex(q => q.id === caption.id);
          caption.updatedBy = this.userId;
          caption.updatedDate = new Date();
          this.questionnaire.questions[index] = caption;
        } else {
          caption.id = this.layoutService.generateUUID();
          caption.isCaption = true;
          caption.createdBy = this.userId;
          caption.createdDate = new Date();
          caption.position = this.questionnaire.questions.length + 1;
          this.questionnaire.questions.push(caption);
        }

        this.isCaptionCollapsed = true;
        break;
    }

    this.setQuestionsPosition();
  }

  isQuestionDeleted(item: Question) {
    if (item.isDeleted === null) return false;
    return item.isDeleted;
  }

  isNewQuestionnaire() {
    return this.questionnaire?.id === 'new';
  }

  isSaveDisabled() {
    return this.questionnaire?.questionnaireName === '' || this.questionnaire?.questions.length === 0;
  }
}
